<template>
    <!-- テストランメモ -->
    <fieldset id="testrunMemo">
        <legend>テストランメモ(任意)</legend>
        <div>
            テストラン実行時のメモを入力して下さい。
        </div>
        <div class="form-area">
            <label for="testrunMemoForm">・テストラン実行時のメモ</label><br>
            <input type="text" class="input-text" v-model="inputedTestrunMemo" name="testrunMemo" @input="updateOpt"
                placeholder="メモ">
        </div>
    </fieldset>
</template>

<script>
import { onMounted, ref } from 'vue';

import strUtils from '@/js/strUtils';
import cacheUtils from '@/js/cacheUtils';

export default {
    name: 'TestrunMemoForm',
    setup(_, { emit }) {
        // ###############
        // フォームデータ #
        // ###############
        const inputedTestrunMemo = ref("")

        // #############
        // コマンド生成 #
        // #############
        const updateOpt = async () => {
            let createdOpt = ""

            // テストランメモ
            if (inputedTestrunMemo.value) {
                inputedTestrunMemo.value = await strUtils.deleteSpace(inputedTestrunMemo.value)
                createdOpt += ` --testrun_memo ${inputedTestrunMemo.value}`
            }

            // cacheに保存
            await cacheUtils.saveData("testrunMemo", inputedTestrunMemo.value)

            // コマンド生成&表示は親コンポーネント
            emit("update-opt", "testrunMemo", createdOpt)
        }

        // ###############
        // ライフサイクル #
        // ###############
        onMounted(async () => {
            // cacheから取り出し
            inputedTestrunMemo.value = await cacheUtils.getData("testrunMemo")

            await updateOpt()
        })

        return {
            // フォームデータ
            inputedTestrunMemo,
            // コマンド生成
            updateOpt,
        }
    }
}
</script>
